var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlyingMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 1028.4-6 24-9.3898-4.7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 1028.4-18 18-6-3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 1046.4 1 6 1.6737-4.7 15.326-19.3z",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 1052.4 3-4-1.339-0.7z",
    fill: "#474747"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingMail);
export default __webpack_public_path__ + "static/media/flying-mail.d837f5717020dca96b1556db2a054166.svg";
export { ForwardRef as ReactComponent };